import { global } from ":shared/app";

const endpoint = (email: string) => "/account/attendance/certificate?email=" + email;
export type GET = {
  props: {
    email: string;
  };
  returns: {
    email: string;
    name_ar: string;
    name_en: string;
    attendance?: string | boolean;
    top_10?: string | boolean;
    top_3?: string | boolean;
    guinness?: string | boolean;
  };
};

export async function get(props: GET["props"]): Promise<GET["returns"]> {
  // return import("./certificate.mocks").then((ret) => {
  //   return ret.success;
  // });
  return global.api.get(endpoint(props.email)).then((res) => {
    return res.data;
  });
}
